export const RECEIVE_WEB_USER_INFO = 'receive_web_user_info' //保存前台用户信息
export const RECEIVE_ADMIN_USER_INFO = 'receive_admin_user_info' //保存后台用户信息

export const CLEAR_WEB_USER_INFO = 'clear_web_user_info' //清除前台用户信息
export const CLEAR_ADMIN_USER_INFO = 'clear_admin_user_info' //清除后台用户信息

export const UPDATE_WEB_TOKEN = 'update_web_token' //更新前台token
export const UPDATE_ADMIN_TOKEN = 'update_admin_token' //更新后台token
